/* =============================================================================
   Pre-footer circuit "wake" — a soft spot-reveal of the brighter line-art layer
   trailing the cursor. Ported verbatim in behaviour from the marketing site's
   shared prefooter (src/site/pages/press.html and 14 others).

   Fine pointer + motion only: the base line-art stays for everyone, only the
   wake is gated. Position is written to --cx/--cy, which the radial mask in
   bs-chrome.css reads; the easing toward the target is what makes the reveal
   trail the cursor instead of snapping to it.
   ========================================================================== */
(function () {
  var pf = document.getElementById('bs-prefooter');
  if (!pf) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var rect = pf.getBoundingClientRect();
  var refresh = function () { rect = pf.getBoundingClientRect(); };

  var px = 0, py = 0, tx = 0, ty = 0, ticking = false, inside = false;

  var frame = function () {
    px += (tx - px) * 0.16;
    py += (ty - py) * 0.16;
    pf.style.setProperty('--cx', px + 'px');
    pf.style.setProperty('--cy', py + 'px');
    if (Math.abs(tx - px) > 0.5 || Math.abs(ty - py) > 0.5) {
      requestAnimationFrame(frame);
    } else {
      ticking = false;
      pf.style.setProperty('--cx', tx + 'px');
      pf.style.setProperty('--cy', ty + 'px');
    }
  };
  var tick = function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };

  window.addEventListener('pointermove', function (e) {
    var within = e.clientX >= rect.left && e.clientX <= rect.right &&
                 e.clientY >= rect.top && e.clientY <= rect.bottom;
    if (within) {
      tx = e.clientX - rect.left;
      ty = e.clientY - rect.top;
      if (!inside) {
        /* jump to the entry point so the wake doesn't sweep in from a stale spot */
        inside = true; px = tx; py = ty;
        pf.style.setProperty('--cx', px + 'px');
        pf.style.setProperty('--cy', py + 'px');
        pf.classList.add('is-probing');
      } else {
        tick();
      }
    } else if (inside) {
      inside = false;
      pf.classList.remove('is-probing');
    }
  }, { passive: true });

  /* the band is absolutely placed, so its viewport rect moves with the page */
  window.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
})();
